<template>
  <router-link to="/" class="blox-up-text">Blox<span>Up</span></router-link>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "IconClear",
})
</script>

<style></style>

<style lang="scss" scoped>
.blox-up-text {
  width: 123px;
  height: 24px;

  font-family: "Druk Text Wide Cyr";
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 24px;
  text-transform: uppercase;

  span {
    background: var(--text-gradient-165);
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>
